export enum TeamCategory {
    FULFILLMENT = 'FULFILLMENT',
    MARKETING = 'MARKETING',
    TECHNOLOGY_AND_CONTENT = 'TECHNOLOGY_AND_CONTENT',
    GENERAL_AND_ADMINISTRATIVE = 'GENERAL_AND_ADMINISTRATIVE',
}
